// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* pages/Home.css */
.home-page {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.highlight-card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    border-radius: 12px;
}

.highlight-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.icon-wrapper {
    width: 60px;
    height: 60px;
    background-color: rgba(0, 123, 255, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1rem auto;
}

.affiliation-item {
    transition: transform 0.3s ease;
}

.affiliation-item:hover {
    transform: translateY(-3px);
}

.publication-item {
    transition: transform 0.2s ease;
    border-left: 4px solid #007BFF;
}

.publication-item:hover {
    transform: translateX(5px);
}

/* Smooth scrolling for anchor links */
html {
    scroll-behavior: smooth;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .display-3 {
        font-size: 2.5rem;
    }
    
    .display-5 {
        font-size: 2rem;
    }
    
    .btn-lg {
        margin-bottom: 1rem;
        width: 100%;
    }
}

`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,4DAA4D;AAChE;;AAEA;IACI,qDAAqD;IACrD,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,qDAAqD;AACzD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,sCAAsC;AACtC;IACI,uBAAuB;AAC3B;;AAEA,2BAA2B;AAC3B;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,WAAW;IACf;AACJ","sourcesContent":["/* pages/Home.css */\n.home-page {\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.highlight-card {\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    border-radius: 12px;\n}\n\n.highlight-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;\n}\n\n.icon-wrapper {\n    width: 60px;\n    height: 60px;\n    background-color: rgba(0, 123, 255, 0.1);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 1rem auto;\n}\n\n.affiliation-item {\n    transition: transform 0.3s ease;\n}\n\n.affiliation-item:hover {\n    transform: translateY(-3px);\n}\n\n.publication-item {\n    transition: transform 0.2s ease;\n    border-left: 4px solid #007BFF;\n}\n\n.publication-item:hover {\n    transform: translateX(5px);\n}\n\n/* Smooth scrolling for anchor links */\nhtml {\n    scroll-behavior: smooth;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .display-3 {\n        font-size: 2.5rem;\n    }\n    \n    .display-5 {\n        font-size: 2rem;\n    }\n    \n    .btn-lg {\n        margin-bottom: 1rem;\n        width: 100%;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
